module.exports = __webpack_public_path__ + "static/video1-83cb8abdf0a2db395557957adbfd956c.png";